// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__1VC87","item":"Header_item__3IlmB","logo":"Header_logo__3_SJs","collapsed":"Header_collapsed__M0SRF","rightPanel":"Header_rightPanel__2AcVB"};